import { render, staticRenderFns } from "./new-year.vue?vue&type=template&id=1c872172&scoped=true&"
import script from "./new-year.vue?vue&type=script&lang=js&"
export * from "./new-year.vue?vue&type=script&lang=js&"
import style0 from "./new-year.vue?vue&type=style&index=0&id=1c872172&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c872172",
  null
  
)

export default component.exports